import ProductDescription from './ProductDescription'

const BSQuinoaProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '014',
  IsBroadband: true,
  Size: '',
}

export default BSQuinoaProduct
